import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {DEFAULT_LOCALE, Locale} from '../../model/Locale';
import {TenantService} from '../../service/tenant.service';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../service/auth.service';
import {Session} from '../../model/auth/Session';
import {User} from '../../model/auth/User';

@Component({
  selector: 'app-service-privacy',
  templateUrl: './service-privacy.component.html',
  styleUrls: ['./service-privacy.component.scss']
})
export class ServicePrivacyComponent implements OnInit {

  readonly locales = Locale;
  readonly locale: Locale;

  private tenantDomain?: string;

  serviceUrl!: string;

  supportEmail: string;
  supportEmailLabel: string;

  user?: User | null;

  constructor(private tenantService: TenantService,
              private authService: AuthService,
              @Inject(LOCALE_ID) locale: string) {
    this.locale = locale as Locale || DEFAULT_LOCALE;

    this.supportEmailLabel = environment.contacts.supportEmail;
    this.supportEmail = 'mailto:' + this.supportEmailLabel;
  }

  async ngOnInit(): Promise<void> {
    this.user = await this.authService.getUser();
    const tenant = this.tenantService.getTenant();
    if (tenant) {
      this.tenantDomain = tenant.domain;
    }

    this.serviceUrl = `https://${this.tenantDomain ? this.tenantDomain + '.' : ''}${environment.ui.host}/`;
  }

}
